export const MAX_RECORDING_DURATION_MS = 10_800_000; // 3 hours
// Low-end Android devices routinely need more than 10s to prepare the native recorder.
export const START_RECORDING_TIMEOUT_MS = 15_000;
export const REMAINING_RECORDING_WARNING_SECONDS = 1800; // 30 minutes
export const REMAINING_RECORDING_CRITICAL_SECONDS = 300; // 5 minutes

export const getRemainingRecordingSeconds = (elapsedSeconds: number): number => {
  if (!Number.isFinite(elapsedSeconds)) {
    return 0;
  }

  return Math.max(0, Math.floor(MAX_RECORDING_DURATION_MS / 1000) - elapsedSeconds);
};

export type RemainingRecordingSeverity = 'normal' | 'warning' | 'critical';

export const getRemainingRecordingSeverity = (
  remainingSeconds: number,
): RemainingRecordingSeverity => {
  if (remainingSeconds <= REMAINING_RECORDING_CRITICAL_SECONDS) {
    return 'critical';
  }

  if (remainingSeconds <= REMAINING_RECORDING_WARNING_SECONDS) {
    return 'warning';
  }

  return 'normal';
};

export interface RemainingRecordingDisplay {
  readonly unit: 'hours' | 'minutes';
  readonly value: number;
}

export const getRemainingRecordingDisplay = (
  remainingSeconds: number,
): RemainingRecordingDisplay => {
  if (remainingSeconds >= 3600) {
    return { unit: 'hours', value: Math.round(remainingSeconds / 3600) };
  }

  // Rounding up must not reach a full hour, or the label reads "60m" one
  // second before it would have read "1h".
  return { unit: 'minutes', value: Math.min(59, Math.ceil(remainingSeconds / 60)) };
};
